import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type Language = "en" | "es" | "zh-CN";

interface UiState {
  whoisModalVisible: boolean;
  language: Language;
}

const getSavedLanguage = (): Language => {
  try {
    const saved = localStorage.getItem("language");
    if (saved === "es") return "es";
    if (saved === "zh-CN") return "zh-CN";
    return "en";
  } catch {
    return "en";
  }
};

const initialState: UiState = {
  whoisModalVisible: false,
  language: getSavedLanguage(),
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    showWhoisModal: (state) => {
      state.whoisModalVisible = true;
    },
    hideWhoisModal: (state) => {
      state.whoisModalVisible = false;
    },
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.language = action.payload;
      try {
        localStorage.setItem("language", action.payload);
      } catch {}
    },
    // Updates Redux + i18n display only — does NOT overwrite the stored preference.
    // Use this when the URL forces a language context (e.g. domain pages) so the
    // user's saved preference is preserved for when they navigate away.
    setLanguageSilent: (state, action: PayloadAction<Language>) => {
      state.language = action.payload;
    },
  },
});

export const { hideWhoisModal } = uiSlice.actions;

export default uiSlice;
